import * as Spring from "react-spring";

export function cardModal(modalOpen: boolean) {
	return Spring.useTransition(modalOpen, null, {
		from: { opacity: 0, transform: "translateY(-15px)" },
		enter: { opacity: 1, transform: "translateY(0px)" },
		leave: { opacity: 0, transform: "translateY(-15px)" }
	});
}
